(function () {

    TimesheetSettingsService.$inject = ['$q', 'TeamScheduleService','actualClockTimeManagementService'];

    function TimesheetSettingsService($q, TeamScheduleService, actualClockTimeManagementService) {

        var self = this;

        var cache = {};
        var premiumPayIgnoreReasonsCache = {};
        var callInIgnoreReasonsCache = {};
        var finalFWWIgnoreReasonsCache = {};

        self.loadTimesheetSettings = function () {

            var defer = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {

                    var brandId = brand.id;

                    if (cache[brandId]) {
                        defer.resolve(angular.copy(cache[brandId]));
                    }
                    else {
                        var promise;

                        if (environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE) {
                            promise = PerformanceAggregatorAPI
                                .getEmployeeTimesheetSettings(brandId);
                        }
                        else {
                            promise = GatewayTeamLiveAPI
                                .getEmployerTimesheetSettings(brandId);
                        }

                        promise
                            .then(function (settings) {
                                if (settings.errors_lookups) {
                                    settings.errors_lookups = _.filter(settings.errors_lookups, function(errorsLookup) {
                                        return ['FAIR_WORK_WEEK_PENALTY', 'FINAL_FAIR_WORK_WEEK_PENALTY'].indexOf(errorsLookup.type) === -1;
                                    });
                                }
                                cache[brandId] = settings;
                                defer.resolve(angular.copy(cache[brandId]));
                            })
                            .catch(function (err) {
                                defer.reject(err);
                            });
                    }
                });


            return defer.promise;
        };

        self.isOfflineModeEnabled = function () {
            var defer = $q.defer();

            self.loadTimesheetSettings()
                .then(function (settings) {
                    defer.resolve(settings && settings['offline_mode'] && settings['offline_mode'].status === 'ACTIVE');
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };


        self.isSickLeaveEnabled = function () {
            var defer = $q.defer();

            self.loadTimesheetSettings()
                .then(function (settings) {
                    defer.resolve(settings.sick_leave.enable_sick_leave);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getClockLoginSettings = function () {
            var defer = $q.defer();

            self.loadTimesheetSettings()
                .then(function (settings) {
                    defer.resolve(settings.clock_login_settings);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getBrandTimesheetData = function (brandId, dataType, date) {
            var defer = $q.defer();
            PerformanceAggregatorAPI.getTimesheetRetrievalSettings(brandId)
                .then(function (res) {
                    var promise;

                    if (res['brand_timesheet_retrieval_mode'] === 'LAMBDA') {
                        promise = GatewayTeamLiveAPI.getBrandTimesheet(brandId, dataType, date);
                    } else {
                        promise = PerformanceAggregatorAPI.getBrandTimesheet(brandId, dataType, date);
                    }

                    promise
                        .then(function (timesheetData) {
                            defer.resolve(timesheetData);
                        })
                        .catch(function (err) {
                            defer.reject(err);
                        });
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.getPremiumPayIgnoreReasons = function () {

            var defer = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {

                    var brandId = brand.id;

                    if (premiumPayIgnoreReasonsCache[brandId]) {
                        defer.resolve(angular.copy(premiumPayIgnoreReasonsCache[brandId]));
                    }
                    else {
                        var promise;

                        if (environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE) {
                            promise = PerformanceAggregatorAPI.getEmployeeTimesheetSettings(brandId);
                        } else {
                            promise = GatewayTeamLiveAPI.getEmployerTimesheetSettings(brandId);
                        }

                        promise
                            .then(function (settings) {
                                var reasons = _.find(settings.errors_lookups, {type: "FAIR_WORK_WEEK_PENALTY"});
                                premiumPayIgnoreReasonsCache[brandId] = reasons;
                                defer.resolve(angular.copy(reasons));
                            })
                            .catch(function (err) {
                                defer.reject(err);
                            });
                    }
                });


            return defer.promise;
        };

        self.getCallInIgnoreReasons = function () {

            var defer = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {

                    var brandId = brand.id;

                    if (callInIgnoreReasonsCache[brandId]) {
                        defer.resolve(angular.copy(callInIgnoreReasonsCache[brandId]));
                    }
                    else {
                        var promise;

                        if (environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE) {
                            promise = PerformanceAggregatorAPI.getEmployeeTimesheetSettings(brandId);
                        } else {
                            promise = GatewayTeamLiveAPI.getEmployerTimesheetSettings(brandId);
                        }

                        promise
                            .then(function (settings) {

                                var reasons = _.find(settings.errors_lookups, {type: "CALL_IN"});
                                callInIgnoreReasonsCache[brandId] = reasons;
                                defer.resolve(angular.copy(reasons));
                            })
                            .catch(function (err) {
                                defer.reject(err);
                            });
                    }
                });


            return defer.promise;
        };

        self.getFinalFWWExceptions = function () {

            var defer = $q.defer();

            TeamScheduleService.getActiveBrand()
                .then(function (brand) {

                    var brandId = brand.id;

                    if (finalFWWIgnoreReasonsCache[brandId]) {
                        defer.resolve(angular.copy(finalFWWIgnoreReasonsCache[brandId]));
                    }
                    else {
                        var promise;

                        if (environmentsConfig.getEnv().host == environmentsConfig.TEAM_SCHEDULE) {
                            promise = PerformanceAggregatorAPI.getEmployeeTimesheetSettings(brandId);
                        } else {
                            promise = GatewayTeamLiveAPI.getEmployerTimesheetSettings(brandId);
                        }

                        promise
                            .then(function (settings) {
                                var reasons = _.find(settings.errors_lookups, {type: "FINAL_FAIR_WORK_WEEK_PENALTY"});
                                finalFWWIgnoreReasonsCache[brandId] = reasons;
                                defer.resolve(angular.copy(reasons));
                            })
                            .catch(function (err) {
                                defer.reject(err);
                            });
                    }
                });


            return defer.promise;
        };

        self.getTimesheetErrorsFlatList = function (includeArchived) {
            var defer = $q.defer();

            var promises = {};

            promises['settings'] = self.loadTimesheetSettings();
            promises['is_sick_leave_enabled'] = self.isSickLeaveEnabled();

            $q.all(promises)
                .then(function (result) {
                    var errorsCategory = [];
                    var settings = result['settings'];

                    errorsCategory = actualClockTimeManagementService.formatErrorCategory(settings, result['is_sick_leave_enabled'], includeArchived);

                    defer.resolve(errorsCategory);
                })
                .catch(function (err) {
                    defer.reject(err);
                });

            return defer.promise;
        };

        self.resetTimesheetSettingsCache = function () {
            cache = {};
        };
    }

    app.service('TimesheetSettingsService', TimesheetSettingsService);

})();
